const __activate = {
  method: "POST",
  url: "sim/activate",
};

const __updateActivate = (uuid) => ({
  method: "POST",
  url: `sim/activate/${uuid}/update`,
});

const __getActivateBatches = {
  method: "GET",
  url: "sim/activate/batches",
};

const __activateTelit = {
  method: "POST",
  url: "sim/activate/telit",
};

const __activateSparq = {
  method: "POST",
  url: "sim/activate/sparq",
};

const __activateCricket = {
  method: "POST",
  url: "sim/activate/cricket",
};

const __activateVerizon = {
  method: "POST",
  url: "sim/activate/verizon",
};

const __activateTmobile = {
  method: "POST",
  url: "sim/activate/tmobile",
};

const __activateOPN = {
  method: "POST",
  url: "sim/activate/opn",
};

const __activateTmobilej = {
  method: "POST",
  url: "sim/activate/tmobilej",
};

const __activateIT = {
  method: "POST",
  url: "sim/activate/it",
};


const __getActivate = {
  method: "GET",
  url: "sim/activate",
};

const __getActivateLog = (id) => ({
  method: "GET",
  url: `sim/activate/${id}`,
});

const __pause = {
  method: "POST",
  url: "sim/pause",
};

const __pauseTelit = {
  method: "POST",
  url: "sim/pause/telit",
};

const __pauseSelectel = {
  method: "POST",
  url: "sim/pause/selectel",
};

const __pauseSelectelRecheck = {
  method: "POST",
  url: "sim/pause/selectel/recheck",
};

const __getPause = {
  method: "GET",
  url: "sim/pause",
};

const __getPauseBatches = {
  method: "GET",
  url: "sim/pause/batches",
};

const __getPauseLog = (id) => ({
  method: "GET",
  url: `sim/pause/${id}`,
});

const __deactivate = {
  method: "POST",
  url: "sim/deactivate",
};

const __deactivateTelit = {
  method: "POST",
  url: "sim/deactivate/telit",
};

const __deactivateSparq = {
  method: "POST",
  url: "sim/deactivate/sparq",
};

const __getDeactivate = {
  method: "GET",
  url: "sim/deactivate",
};

const __getDeactivateBatches = {
  method: "GET",
  url: "sim/deactivate/batches",
};

const __getDeactivateLog = (id) => ({
  method: "GET",
  url: `sim/deactivate/${id}`,
});

const __restore = {
  method: "POST",
  url: "sim/restore",
};

const __unpauseSelectel = {
  method: "POST",
  url: "sim/unpause/selectel",
};

const __unpauseSelectelRecheck = {
  method: "POST",
  url: "sim/unpause/selectel/recheck",
};

const __getRestore = {
  method: "GET",
  url: "sim/restore",
};

const __getRestoreBatches = {
  method: "GET",
  url: "sim/restore/batches",
};

const __getRestoreLog = (id) => ({
  method: "GET",
  url: `sim/restore/${id}`,
});

const __unpause = {
  method: "POST",
  url: "sim/unpause",
};

const __getUnpause = {
  method: "GET",
  url: "sim/unpause",
};

const __getUnpauseBatches = {
  method: "GET",
  url: "sim/unpause/batches",
};

const __getUnpauseLog = (id) => ({
  method: "GET",
  url: `sim/unpause/${id}`,
});

const __changeNumber = {
  method: "POST",
  url: "sim/change_number",
};

const __updateChangeNumber = (uuid) => ({
  method: "POST",
  url: `sim/change_number/${uuid}/update`,
});

const __changeNumberTelit = {
  method: "POST",
  url: "sim/change_number/telit",
};

const __changeNumberSelectel = {
  method: "POST",
  url: "sim/change_number/selectel",
};

const __changeNumberSelectelRecheck = {
  method: "POST",
  url: "sim/change_number/selectel/recheck",
};

const __changeNumberTmobilej = {
  method: "POST",
  url: "sim/change_number/tmobilej",
};

const __changeNumberIT = {
  method: "POST",
  url: "sim/change_number/it",
};

const __getChangeNumber = {
  method: "GET",
  url: "sim/change_number",
};

const __getChangeNumberBatches = {
  method: "GET",
  url: "sim/change_number/batches",
};

const __getChangeNumberLog = (id) => ({
  method: "GET",
  url: `sim/change_number/${id}`,
});

const __changeSimUltra = {
  method: "POST",
  url: "sim/change_sim",
};

const __changeSimSelectel = {
  method: "POST",
  url: "sim/change_sim/selectel",
};

const __getChangeSim = {
  method: "GET",
  url: "sim/change_sim",
};

const __getChangeSimBatches = {
  method: "GET",
  url: "sim/change_sim/batches",
};

const __getChangeSimLog = (id) => ({
  method: "GET",
  url: `sim/change_sim/${id}`,
});

const __getSimInfo = {
  method: "GET",
  url: "sim/sim_info",
};

const __getSimInfoBatches = {
  method: "GET",
  url: "sim/sim_info/batches",
};

const __fetchSimInfo = {
  method: "POST",
  url: "sim/sim_info",
};

const __fetchSimTelitInfo = {
  method: "POST",
  url: "sim/sim_info/telit",
};

const __fetchImsiStatus = {
  method: "POST",
  url: "sim/sim_info/imsi",
};

const __fetchSimSelectelInfo = {
  method: "POST",
  url: "sim/sim_info/selectel",
};

const __fetchSimOPNInfo = {
  method: "POST",
  url: "sim/sim_info/opn",
};

const __fetchSimTmobilejInfo = {
  method: "POST",
  url: "sim/sim_info/tmobilej",
};

const __fetchSimVSInfo = {
  method: "POST",
  url: "sim/sim_info/vs",
};

const __fetchSimITInfo = {
  method: "POST",
  url: "sim/sim_info/it",
};

const __fetchSimNyxInfo = {
  method: "POST",
  url: "sim/sim_info/nyx",
};

const __export = {
  method: "GET",
  url: "sim/export",
};

const __getPlans = {
  method: "GET",
  url: "sim/plans",
};

const __retryOperation = (batch_id) => ({
  method: "POST",
  url: `sim/retry_failed/${batch_id}`,
});

const __changePlan = {
  method: "POST",
  url: "sim/change_plan",
};

const __getChangePlanBatches = {
  method: "GET",
  url: "sim/change_plan/batches",
};

const __changePlanTelit = {
  method: "POST",
  url: "sim/change_plan/telit",
};

const __getChangePlan = {
  method: "GET",
  url: "sim/change_plan",
};

const __getChangePlanLog = (id) => ({
  method: "GET",
  url: `sim/change_plan/${id}`,
});

const __getRefillBatches = {
  method: "GET",
  url: "sim/refill/batches",
};

const __refillCricket = {
  method: "POST",
  url: "sim/refill/cricket",
};

const __refillOPN = {
  method: "POST",
  url: "sim/refill/opn",
};

const __refillVerizon = {
  method: "POST",
  url: "sim/refill/verizon",
};

const __getRefill = {
  method: "GET",
  url: "sim/refill",
};

const __getRefillLog = (id) => ({
  method: "GET",
  url: `sim/refill/${id}`,
});

const __getTelitExportList = {
  method: "GET",
  url: "sim/telit_export",
};

const __getTelitExportFile = {
  method: "GET",
};

const __telit_export = {
  method: "POST",
  url: "sim/sim_info/telit/export",
};

const __getTmobilejExportList = {
  method: "GET",
  url: "sim/tmobilej_export",
};

const __getTmobilejExportFile = {
  method: "GET",
};

const __tmobilej_export = {
  method: "POST",
  url: "sim/sim_info/tmobilej/export",
};

const __retryTmobilejExport = {
  method: "POST",
};

// VS Export (history + file + trigger)
const __getVSExportList = {
  method: "GET",
  url: "sim/vs_export",
};

const __getVSExportFile = {
  method: "GET",
};

const __vs_export = {
  method: "POST",
  url: "sim/sim_info/vs/export",
};

const __getZipCheckList = {
  method: "GET",
  url: "sim/zip_check",
};

const __getZipCheckFile = {
  method: "GET",
};

const __zipCheck = {
  method: "POST",
  url: "sim/sim_info/zip",
};

const __checkStatus = (batch_id) => ({
  method: "POST",
  url: `sim/recheck_status/${batch_id}`,
});

const __terminateProcess = (batch_id) => ({
  method: "POST",
  url: `sim/stop_batch/${batch_id}`,
});

const __getSparqSimGroups = {
  method: "GET",
  url: "sim/sparq_sim_group",
};

const __getCredential = (client) => ({
  method: "GET",
  url: `sim/credentials/${client}`,
});

const __updateCredential = (client) => ({
  method: "PUT",
  url: `sim/credentials/${client}`,
});

const __portin = {
  method: "POST",
  url: "sim/portin",
};

const __getPortinBatches = {
  method: "GET",
  url: "sim/portin/batches",
};

const __portinUltra = {
  method: "POST",
  url: "sim/portin/ultra",
};

const __portinTmobilej = {
  method: "POST",
  url: "sim/portin/tmobilej",
};

const __portinVS = {
  method: "POST",
  url: "sim/portin/vs",
};

const __getPortin = {
  method: "GET",
  url: "sim/portin",
};

const __getPortinLog = (id) => ({
  method: "GET",
  url: `sim/portin/${id}`,
});

// Update Number
const __getUpdateNumber = {
  method: "GET",
  url: "sim/update_number",
};

const __getUpdateNumberBatches = {
  method: "GET",
  url: "sim/update_number/batches",
};

const __getUpdateNumberLog = (id) => ({
  method: "GET",
  url: `sim/update_number/${id}`,
});

const __updateNumberTmobilej = {
  method: "POST",
  url: "sim/update_number/tmobilej",
};

const __updateNumberVS = {
  method: "POST",
  url: "sim/update_number/vs",
};

// Webhooks for update_number forms
const __getTmobilejWebhooks = {
  method: "GET",
  url: "sim/webhooks/tmobilej",
};

const __getVSWebhooks = {
  method: "GET",
  url: "sim/webhooks/vs",
};

const __clientActivate = {
  method: "POST",
  url: "clients/activate",
};

const __clientDeactivate = {
  method: "POST",
  url: "clients/deactivate",
};

const __clientChangeNumber = {
  method: "POST",
  url: "clients/change_number",
};

const __clientSimInfo = {
  method: "POST",
  url: "clients/sim_info",
};

const __getUserHistory = {
  method: "POST",
  url: "sim/user_history",
};

const __reset = {
  method: "POST",
  url: "clients/reset/",
};

const __resetAdminUltra = {
  method: "POST",
  url: "sim/reset/",
};

const __resetAdminTelit = {
  method: "POST",
  url: "sim/reset/telit",
};

const __resetImsi = {
  method: "POST",
  url: "sim/reset/imsi",
};

const __getResetBatches = {
  method: "GET",
  url: "sim/reset/batches",
};

const __getReset = {
  method: "GET",
  url: "sim/reset",
};

const __setResetComplete = (batch_id) => ({
  method: "POST",
  url: `sim/reset/${batch_id}/complete`,
});

const __setResetFailed = (batch_id) => ({
  method: "POST",
  url: `sim/reset/${batch_id}/failed`,
});

const __searchLineClient = {
  method: "GET",
  url: `clients/search_lines`,
};

const __searchLine = {
  method: "GET",
  url: `sim/search_lines`,
};

const __hotlineSelectel = {
  method: "POST",
  url: "sim/hotline/selectel",
};

const __getHotline = {
  method: "GET",
  url: "sim/hotline",
};

const __getHotlineBatches = {
  method: "GET",
  url: "sim/hotline/batches",
};

const __getHotlineLog = (id) => ({
  method: "GET",
  url: `sim/hotline/${id}`,
});

const __getEsims = {
  method: "GET",
  url: "sim/esim",
};

const __addUltraEsim = {
  method: "POST",
  url: "sim/esim/ultra",
};

const __wifiCallingAdminUltra = {
  method: "POST",
  url: "sim/wificalling",
};

const __getWifiCallingBatches = {
  method: "GET",
  url: "sim/wificalling/batches",
};

const __getWifiCalling = {
  method: "GET",
  url: "sim/wificalling",
};

const __getWifiCallingLog = (id) => ({
  method: "GET",
  url: `sim/wificalling/${id}`,
});

const __getOrganizations = {
  method: "GET",
  url: "sim/imsi/organizations",
};

const __imsiRegister = {
  method: "POST",
  url: "sim/imsi/register",
};

const __imsiUnregister = {
  method: "POST",
  url: "sim/imsi/unregister",
};

const __getIMSIBatches = {
  method: "GET",
  url: "sim/imsi/batches",
};

const __getIMSI = {
  method: "GET",
  url: "sim/imsi",
};

const __getIMSILog = (id) => ({
  method: "GET",
  url: `sim/imsi/${id}`,
});

const __getImsiWorkflowBatches = {
  method: "GET",
  url: "sim/imsi_workflow/batches",
};

const __getImsiWorkflow = {
  method: "GET",
  url: "sim/imsi_workflow",
};

const __getImsiWorkflowLog = (id) => ({
  method: "GET",
  url: `sim/imsi_workflow/${id}`,
});

const __imsiWorkflow = {
  method: "POST",
  url: "sim/imsi_workflow/ultra",
};

export {
  __activate,
  __updateActivate,
  __getActivate,
  __getActivateBatches,
  __activateTelit,
  __activateSparq,
  __activateCricket,
  __activateVerizon,
  __activateTmobile,
  __activateOPN,
  __activateTmobilej,
  __activateIT,
  __getActivateLog,
  __pause,
  __pauseTelit,
  __pauseSelectel,
  __pauseSelectelRecheck,
  __getPause,
  __getPauseBatches,
  __getPauseLog,
  __deactivate,
  __getDeactivate,
  __getDeactivateBatches,
  __deactivateTelit,
  __deactivateSparq,
  __getDeactivateLog,
  __restore,
  __unpauseSelectel,
  __unpauseSelectelRecheck,
  __getRestore,
  __getRestoreBatches,
  __getRestoreLog,
  __unpause,
  __getUnpause,
  __getUnpauseBatches,
  __getUnpauseLog,
  __changeNumber,
  __updateChangeNumber,
  __changeNumberTelit,
  __changeNumberSelectel,
  __changeNumberSelectelRecheck,
  __changeNumberTmobilej,
  __changeNumberIT,
  __getChangeNumber,
  __getChangeNumberBatches,
  __getChangeNumberLog,
  __changeSimSelectel,
  __changeSimUltra,
  __getChangeSim,
  __getChangeSimBatches,
  __getChangeSimLog,
  __getSimInfo,
  __fetchSimOPNInfo,
  __getSimInfoBatches,
  __fetchSimInfo,
  __fetchSimTmobilejInfo,
  __fetchSimVSInfo,
  __fetchSimITInfo,
  __fetchSimNyxInfo,
  __export,
  __getPlans,
  __retryOperation,
  __changePlan,
  __getChangePlanBatches,
  __changePlanTelit,
  __getChangePlan,
  __getChangePlanLog,
  __getRefillBatches,
  __refillCricket,
  __refillVerizon,
  __refillOPN,
  __getRefill,
  __getRefillLog,
  __getTmobilejExportList,
  __getTmobilejExportFile,
  __retryTmobilejExport,
  __tmobilej_export,
  __getVSExportList,
  __getVSExportFile,
  __vs_export,
  __getTelitExportList,
  __getTelitExportFile,
  __telit_export,
  __getZipCheckList,
  __getZipCheckFile,
  __zipCheck,
  __checkStatus,
  __terminateProcess,
  __getSparqSimGroups,
  __getCredential,
  __updateCredential,
  __portin,
  __getPortinBatches,
  __portinUltra,
  __portinTmobilej,
  __portinVS,
  __getPortin,
  __getPortinLog,
  __getUpdateNumber,
  __getUpdateNumberBatches,
  __getUpdateNumberLog,
  __updateNumberTmobilej,
  __updateNumberVS,
  __getTmobilejWebhooks,
  __getVSWebhooks,
  __fetchSimTelitInfo,
  __fetchImsiStatus,
  __clientActivate,
  __clientChangeNumber,
  __clientDeactivate,
  __clientSimInfo,
  __getUserHistory,
  __reset,
  __resetAdminUltra,
  __resetAdminTelit,
  __resetImsi,
  __getResetBatches,
  __getReset,
  __setResetComplete,
  __setResetFailed,
  __searchLineClient,
  __searchLine,
  __fetchSimSelectelInfo,
  __hotlineSelectel,
  __getHotline,
  __getHotlineBatches,
  __getHotlineLog,
  __addUltraEsim,
  __getEsims,
  __wifiCallingAdminUltra,
  __getWifiCallingBatches,
  __getWifiCalling,
  __getWifiCallingLog,
  __getOrganizations,
  __imsiRegister,
  __imsiUnregister,
  __getIMSIBatches,
  __getIMSI,
  __getIMSILog,
  __getImsiWorkflowBatches,
  __getImsiWorkflow,
  __getImsiWorkflowLog,
  __imsiWorkflow,
};
